const themePreviewStyle = {
    previewContainer: { 
        marginTop: 2, 
        border: `1px solid #000`, 
        borderRadius: 1, 
        overflow: 'hidden',
        fontWeight: '400',
    },
    shadowed: {
        boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'
    },
    header: { 
        width: '100%',
        display: 'flex', 
        justifyContent: 'center',
        alignItems: 'center', 
        height: 30,
    },
    floatinButton: {
        position: 'absolute',
        right: 16,
        bottom: -20,
        width: 40,
        height: 40,
        background: '#fff',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    totalsContainer: {
        backgroundColor: "#fff",
        borderRadius: 1,
        padding: '10px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    secondaryButton: {
        display: 'block',
        marginBottom: 10,
        width: "100%",
    },
    actionButtonsContainer: { 
        justifyContent: 'right', 
        display: 'flex', 
        marginBottom: 10 
    },
    footer: { 
        width: '100%',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        height: 30 
    }
  };
  
  export default themePreviewStyle;
  